import React from 'react';
import { useTranslation } from 'react-i18next';
import { InlineNotification, Select, SelectItem } from '@carbon/react';
import { CurrencyEnum } from '@restavo/shared/enums/currency';

const CurrencySelect = (props: {
  id: string;
  value: CurrencyEnum;
  onChange: (value: CurrencyEnum) => void;
  labelText: string;
  helperText?: string;
  warning?: string;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Select
        id={props.id}
        labelText={props.labelText}
        helperText={props.helperText}
        value={props.value}
        onChange={(event) => props.onChange(event.target.value as CurrencyEnum)}
      >
        <SelectItem value={CurrencyEnum.VND} text={t('common.currencyVND')} />
        <SelectItem value={CurrencyEnum.USD} text={t('common.currencyUSD')} />
      </Select>
      {props.warning && <InlineNotification kind="warning" lowContrast hideCloseButton title={props.warning} />}
    </>
  );
};

export default CurrencySelect;
